{
  "pipes": {
    "appointment_status": {
      "BLOCKER": "Blocker",
      "CONFIRMED": "Bestätigt",
      "CHECKED_IN": "Eingecheckt",
      "FULFILLED": "Bedient",
      "BO_CANCELLED": "Salon hat abgesagt",
      "CUSTOMER_CANCELLED": "Kunde hat abgesagt",
      "EXPIRED": "Abgelaufen",
      "OTHER": "Sonstiges"
    },
    "booking_type": {
      "BLOCKER": "Blocker",
      "AGENT": "KI-Agent",
      "TELEPHONE": "Telefon",
      "ONLINE": "Internet",
      "TREATWELL": "Treatwell",
      "RWG": "Google"
    },
    "communication_way": {
      "EMAIL": "Email",
      "SMS": "SMS",
      "no_matter": "Ganz gleich"
    },
    "customer_type": {
      "vip": "VIP",
      "new": "Neukunde",
      "regular": "Treuer Kunde",
      "at_risk": "Wechselgefährdet",
      "normal": "Normaler Kunde"
    },
    "language": {
      "cs-CZ": "Tschechisch",
      "de-DE": "Deutsch",
      "fr-FR": "Französisch",
      "en-US": "Englisch",
      "vi-VN": "Vietnamesisch"
    },
    "month": [
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember"
    ],
    "notification_type": {
      "NEW_APPOINTMENT": "Neuer Termin",
      "APPOINTMENT_CANCELLED": "Termin vom Kunden abgesagt",
      "APPOINTMENT_MESSAGE": "Neue Nachricht",
      "BO_UPDATED": "Termin vom Salon geändert",
      "BO_CANCELLED": "Termin vom Salon abgesagt"
    },
    "weekday": {
      "MONDAY": "Montag",
      "TUESDAY": "Dienstag",
      "WEDNESDAY": "Mittwoch",
      "THURSDAY": "Donnerstag",
      "FRIDAY": "Freitag",
      "SATURDAY": "Samstag",
      "SUNDAY": "Sonntag"
    },
    "weekday_short": {
      "MONDAY": "Mo.",
      "TUESDAY": "Di.",
      "WEDNESDAY": "Mi.",
      "THURSDAY": "Do.",
      "FRIDAY": "Fr.",
      "SATURDAY": "Sa.",
      "SUNDAY": "So."
    },
    "review_type": {
      "all": "Alle Bewertungstypen",
      "internal_only": "Nur internen Bewertungen",
      "google_only": "Nur Google Bewertungen"
    },
    "time": {
      "day": "Tag",
      "days": "Tage",
      "hour": "Stunde",
      "hours": "Stunden",
      "minute": "Minute",
      "minutes": "Minuten",
      "month": "Monat",
      "months": "Monate",
      "now": "jetzt",
      "second": "Sekunde",
      "seconds": "Sekunden",
      "year": "Jahr",
      "years": "Jahre",
      "timestamp_in_future": "in {{time}}",
      "timestamp_in_the_past": "vor {{time}}",
      "today": "Heute"
    },
    "time_period": {
      "all": "Alle Zeiträume",
      "today": "Heute",
      "yesterday": "Gestern",
      "this_week": "Diese Woche",
      "this_month": "Dieses Monat",
      "last_month": "Letztes Monat",
      "this_quarter": "Dieses Quartal",
      "last_quarter": "Letztes Quartal",
      "this_year": "Dieses Jahr",
      "last_year": "Letztes Jahr"
    },
    "text": {
      "deleted-service": "Gelöschter Service",
      "deleted-staff": "Gelöschte Mitarbeiter",
      "deleted-staff-passive": "Gelöschten Mitarbeiter",
      "first-available-staff": "Erster freier Mitarbeiter",
      "first-available-staff-passive": "Ersten freien Mitarbeiter",
      "other": "andere",
      "others": "anderen",
      "to": "bis",
      "walk_in_customer": "Laufkundschaft"
    }
  }
}
